export enum ROLES {
  ADMIN = "Admin",
  MODERATOR = "Moderator",
  CONTENT_MANAGER = "Content Manager",
}

export enum CONTEST_APPLICATIONS_DEFAULT_FIELD_NAMES {
  phone = "phone",
  email = "email",
  name = "name",
}

export enum HealthStatusEnum {
  Pass = "pass",
  Fail = "fail",
}

export enum SocialLinks {
  facebook = "Facebook",
  telegram = "Telegram",
  viber = "Viber",
  instagram = "Instagram",
  youTube = "YouTube",
  tikTok = "TikTok",
}
